//Library
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import md5 from 'md5';
import { isMobile } from 'react-device-detect';
import Cookies from 'universal-cookie';
import { pushCKStepsToDataLayer,pushUserIdToDataLayer } from '../../utils/analytics.js';

//redux
import { connect } from 'react-redux';
import { getCalFeeRate } from '../../action/anueInfoAction';

class Step2BySec extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectAcct: "acctT",
            prom: [],
            pdfPath: []
        }
    }

    componentWillMount() {
        if (this.props.acctT === undefined && this.props.acctF !== undefined) {
            this.setState({ selectAcct: "acctF" });
        }
        pushUserIdToDataLayer();  //登入
        pushCKStepsToDataLayer(this.props.gid,this.props.gdName,"Checkout-Step2");
    }

    componentDidMount(){
        let cookie = new Cookies();
        if(cookie.get('anueFakeLogin')===true){
            document.getElementById("purchaseSubmit").style.display = 'none';
        }
    }

    acctChange(evt) {
        let divElm = (evt.target.tagName === "DIV") ? evt.target : evt.target.parentElement;
        let items = divElm.children;
        if (this.props.acctF !== undefined && items.length > 1) {
            let selectAcct;
            for (let i = 0; i <= items.length - 1; i++) {
                if (items[i].getAttribute("value") !== this.state.selectAcct) {
                    selectAcct = items[i].getAttribute("value");
                    items[i].setAttribute("style", "background-color: #008cd6;color:#fff;border-radius: 50px");
                } else {
                    items[i].setAttribute("style", "");
                }
            }
            this.setState({ selectAcct: selectAcct !== undefined ? selectAcct : this.state.selectAcct });
        }
    }

    getMinAmount(type) {
        let minAmt;
        if (type === "alt") {
            minAmt = this.props.altMinAmt;
        } else if (type === "rsp") {
            minAmt = this.props.rspMinAmt;
        }

        for (let i = 0; i <= minAmt.length - 1; i++) {
            if (this.state.selectAcct === "acctT" && minAmt[i].ccyCode === "TWD")
                return minAmt[i];
            if (this.state.selectAcct === "acctF" && minAmt[i].ccyCode !== "TWD")
                return minAmt[i];
        }
    }

    checkAmount(altAmt) {
        if (altAmt === "") {
            return false;
        }
        let altMin = this.getMinAmount("alt");
        if (altAmt < altMin.minAmt) {
            Swal.fire("單筆申購金額須大於" + altMin.minAmt + "。");
            return false;
        } else if ((altAmt - altMin.minAmt) % altMin.interAmt !== 0) {
            Swal.fire("單筆申購的申購級距" + altMin.interAmt + "。");
            return false;
        }
        return true;
    }

    amountBlur(evt) {
        let altAmt = document.getElementById("altAmount").value;
        if (this.checkAmount(altAmt)) {
            let data = {
                gid: this.props.gid,
                transWay: "1",
                ccyCode: this.getMinAmount("alt").ccyCode,
                altAmount: parseInt(altAmt),
                rspAmount: 0
            }
            this.props.getCalFeeRate(data, (respones) => {
                this.setState({ prom: respones.data, promText: respones.data[0].promName + parseFloat(respones.data[0].promRate) });
            })
        }
    }

    purchaseSubmit(evt) {
        let altAmt = document.getElementById("altAmount").value;
        let promCode = this.GetCheckboxValue("inlineCheckbox");
        let pwd = document.getElementById("pwd").value;
        if (altAmt === undefined) {
            Swal.fire("申購 金額輸入不完整，請確認。");
            return false;
        } else if (promCode === undefined) {
            Swal.fire("尚未選擇 優惠活動，請確認。");
            return false;
        } else if (document.getElementById("agreeInput").checked === false) {
            Swal.fire("請勾選 交易前詳閱公開說明書、投資人須知、通路報酬與風險預告。");
            return false;
        } else if (pwd === "") {
            Swal.fire("請輸入密碼。");
            return false;
        } else {
            let submitData = {
                ccyCode: this.getMinAmount("alt").ccyCode,
                altAmount: parseInt(altAmt),
                rspAmount: 0,
                invDay: 0,
                promCode: promCode,
                sourceCode: (isMobile) ? 3 : 1,
                accType: (this.state.selectAcct === "acctT") ? "T" : "F",
                pwd: md5(pwd),
                ip: "",
                promText: this.state.promText
            }
            let selAcct = { bankCodeDesc: this.props[this.state.selectAcct].bankCodeDesc, accNo: this.props[this.state.selectAcct].accNo, selAcctType: this.state.selectAcct }
            pushCKStepsToDataLayer(this.props.gid,this.props.gdName,"Checkout-Step3");
            this.props.purchaseComplete(submitData, selAcct, 0, this.state.promText);
        }
    }

    GetRadioValue(radioName) {
        let radios = document.getElementsByName(radioName);
        for (let i = 0; i < radios.length; i++) {
            let radio = radios.item(i);
            if (radio.checked) {
                return { value: radio.value, text: radio.getAttribute("data-text") };
            }
        }
        return undefined;
    }

    GetCheckboxValue(checkboxName) {
        let checkboxs = document.getElementsByName(checkboxName);
        let ck = [];
        let j = 0;
        for (let i = 0; i < checkboxs.length; i++) {
            let checkbox = checkboxs[i];
            if (checkbox.checked) {
                ck[j] = checkbox.value;
                j++;
            }
        }
        return j === 0 ? undefined : ck.join();
    }

    render() {
        return <div className="anueContainer combinationContainer">
            <div className="combinationSub">申購您的投資組合</div>
            <div className="combinationTitle">
                <div className="titleFont">{this.props.gdName}</div>
            </div>
            <div className="progressIndex">
                <div className="progressItem active">
                    <h5><i>1</i><span>申購確認</span></h5>
                </div>
                <div className="progressItem">
                    <h5><i>2</i><span>申購完成</span></h5>
                </div>
            </div>
            <h3 className="comfirmTitle">申購基金明細</h3>
            <div className="comfirmBox">
                {
                    this.props.mktFunds !== undefined ?
                        this.props.mktFunds.map(({ mktName, ratio, fundID, shortName, intro }, index) => {
                            return <div key={index}>
                                <div className="combinationName">
                                    <h5>{mktName}</h5>
                                    <div className="tag">{ratio * 100}%</div>
                                </div>
                                <div className="fundDetail">
                                    <h4>{"(" + fundID + ")" + shortName}</h4>
                                    <p>{intro}</p>
                                </div>
                            </div>
                        }) : ""
                }
            </div>
            <h3 className="comfirmTitle">扣款帳號</h3>
            <div className="comfirmBox">
                <div className="calFlexbox">
                    <div>
                        <div className="gap">
                            <div className="inputGroup">
                                <label>交易幣別</label>
                                <div className="currencySelect" style={{ width: "103px" }} onClick={(evt) => { this.acctChange(evt); }}>
                                    {
                                        this.props.acctT !== undefined ?
                                            <span value="acctT" style={{ backgroundColor: "#008cd6", color: "#fff", borderRadius: "50px", flex: "auto" }}>台幣</span> : ""
                                    }
                                    {
                                        this.props.acctF !== undefined ?
                                            <span value="acctF" style={{ backgroundColor: "#008cd6", color: "#fff", borderRadius: "50px", flex: "auto" }}>美金</span> : ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="calFlexbox fullWidth">
                    <div>
                        <div className="inputGroup">
                            <label>扣款帳號</label>
                            <div className="infoContainer">
                                <p>銀行：{this.props[this.state.selectAcct].bankCodeDesc}</p>
                                <p>帳號：{this.props[this.state.selectAcct].accNo}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="calFlexbox">
                    <div>
                        <div className="gap">
                            <div className="inputGroup">
                                <label>單筆投資</label>
                                <input className="form-control" type="number" id="altAmount" onBlur={(evt) => { this.amountBlur(evt) }} autoComplete="off" />
                                <span style={{ display: "block", width: "206px", textAlign: "center", color: "darkgrey", fontSize: "14px" }}>{this.state.selectAcct === "acctT" ? "最低申購50,000元" : "最低申購1,700元"}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="calFlexbox">
                    <div>
                        <div className="inputGroup inlineRadios">
                            <label>優惠活動</label>
                            <div className="inlineRadioBlock" style={{ marginBottom: "10px" }}>
                                {
                                    this.state.prom.length !== 0 ?
                                        this.state.prom.map(({ promName, promCode, promRate }, index) => {
                                            return <div className="form-check form-check-inline">
                                                {
                                                    index === 0 ?
                                                        <input className="form-check-input" id={"inlineCheckbox" + index} name="inlineCheckbox" type="checkbox" data-promname={promName} data-promrate={promRate} value={promCode} defaultChecked onClick={() => { this.setState({ promText: promName + parseFloat(promRate) }) }} /> :
                                                        <input className="form-check-input" id={"inlineCheckbox" + index} name="inlineCheckbox" type="checkbox" data-promname={promName} data-promrate={promRate} value={promCode} onClick={() => { this.setState({ promText: promName + parseFloat(promRate) }) }} />
                                                }
                                                <label className="form-check-label" htmlFor={"inlineCheckbox" + index}><span>
                                                    <div className="checkmark"></div></span><span>{promName + parseFloat(promRate)}%</span></label>
                                            </div>
                                        }) : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h3 className="comfirmTitle">投資人須知、公開說明書、通路報酬與風險預告		</h3>
            <div className="comfirmBox">
                {
                    this.props.selectPDF !== undefined ?
                        this.props.selectPDF.map(({ fundID, fundName, investorInfo, profit, prospectus }, index) => {
                            return <div className="fundDetail forPDF" key={index}>
                                <h4>{"（" + fundID + "）" + fundName}</h4>
                                <div className="pdfContainer">
                                    <div>
                                        <div className="gap"><a className="btn btn-normal" href={investorInfo} target="_blank" rel="noopener noreferrer">投資人須知</a></div>
                                    </div>
                                    <div>
                                        <div className="gap"><a className="btn btn-normal" href={prospectus} target="_blank" rel="noopener noreferrer">公開說明書</a></div>
                                    </div>
                                    <div>
                                        <div className="gap"><a className="btn btn-normal" href={profit} target="_blank" rel="noopener noreferrer">通路報酬</a></div>
                                    </div>
                                    <div>
                                        <div className="gap"><a className="btn btn-normal" href="./assets/pdf/Risk.pdf" target="_blank" rel="noopener noreferrer">風險預告</a></div>
                                    </div>
                                </div>
                            </div>
                        }) : ""
                }
            </div>
            <div className="inlineRadioBlock agreeBox">
                <div className="form-check form-check-inline">
                    <input className="form-check-input" id="agreeInput" type="checkbox" value="1" />
                    <label className="form-check-label" htmlFor="agreeInput"><span>
                        <div className="checkmark"></div></span><span>本人已於交易前詳閱並同意以上相關文件及服務條款，並已閱讀及了解基金通路報酬揭露及風險預告。</span></label>
                </div>
            </div>
            <div className="calFlexbox passwordContainer">
                <div>
                    <div className="gap">
                        <div className="inputGroup">
                            <input id="pwd" className="form-control form-control-sm" type="password" placeholder="請輸入交易密碼" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="buttonContainer">
                <button className="btn btn-third round" id="step2PrevBtn" onClick={() => { this.props.backStep0() }}>上一步</button>
                <button className="btn btn-primary round main" id="purchaseSubmit" onClick={(evt) => { this.purchaseSubmit(evt) }} href="#">下一步</button>
            </div>
            <div className="cartNote">
                <h5>注意事項</h5>
                <p>若超過本營業日交易時間13:00，為下一營業日之交易；基金淨值日之計算，依基金公司規定為準，委託交易內容已發至您的電子郵件信箱。請您於扣款日當日14:00前，將款項存入您的扣款指定帳號，以避免扣款失敗情形發生，交易確認書於三至五個營業日內寄至您的電子郵件信箱。如有任何問題，歡迎來電鉅亨投顧。</p>
            </div>
        </div>
    }
}
function mapStateToProps(state) {
    return {
        acctF: state.anueInfoState.acctF,
        acctT: state.anueInfoState.acctT,
        altMinAmt: state.anueInfoState.altMinAmt,
        rspMinAmt: state.anueInfoState.rspMinAmt,
        selectPDF: state.anueInfoState.selectPDF,
    };
}

export default connect(mapStateToProps, { getCalFeeRate })(Step2BySec);